import React, { useEffect } from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import { ILink } from 'tbk-components/src/components/Button';
import Icon from 'tbk-components/src/components/Icon';

export interface IAntennaSelectionGainValueProps extends IBaseElementProps {
	topLeftText?: string;
	topRightLink?: ILink;
	inputLabel?: string;
	minValue?: number;
	maxValue?: number;
	unit?: string;
	updateQuery?: (query: any) => void;
	disabled?: boolean;
}

const AntennaSelectionGainValue: React.FC<IAntennaSelectionGainValueProps> = ({
	inputLabel,
	topLeftText,
	topRightLink,
	minValue,
	maxValue,
	unit,
	updateQuery,
	disabled,
	className,
	classNames = [],
}) => {
	const [inputValue, setInputValue] = React.useState(0);

	// The width of the input field adjusts based on content
	const inputWidth = {
		width: `${inputValue.toString().length + 5}ch`,
	};

	useEffect(() => {
		if (disabled) setInputValue(0);
	}, [disabled]);

	return (
		<div className={className || cn('gain-value', ...classNames)}>
			{(topLeftText || topRightLink) && (
				<div className="gain-value__top-text">
					{topLeftText && (
						<div className="subheading">{topLeftText}</div>
					)}
					{topRightLink && (
						<a href={topRightLink?.href}>
							{topRightLink?.label}
							<Icon name="new-window" />
						</a>
					)}
				</div>
			)}
			<div className="gain-value__value">
				<div className="gain-value__value-container">
					<label htmlFor="gainValue">{inputLabel}</label>

					<div className="gain-value__input-unit">
						<input
							type="number"
							id="gainValue"
							value={inputValue}
							onChange={(e) => {
								setInputValue(parseFloat(e.target.value));
								updateQuery &&
									updateQuery(parseFloat(e.target.value));
							}}
							style={inputWidth}
							min={minValue}
							max={maxValue}
							disabled={disabled}
						/>
						{unit}
					</div>
				</div>
			</div>
		</div>
	);
};

export default AntennaSelectionGainValue;
